<template>
    <div class="date-wrapper">
        <div class="calendar-week">
            <button class="meals-date" id="meals-datepicker" :data-date-start-date="programmeStartDate" data-date-end-date="0d">{{ weekNumber+__('. programme week') }}</button>
            <span></span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            mealsDates: {
                type: Array,
                required: false
            },
            mealsNotifications: {
                type: Array,
                required: false
            },
            patientProgrammeStart: {
                type: String,
                required: true
            },
            weekStart: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                programmeStartDate: moment(this.patientProgrammeStart, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
            }
        },
        watch: {
            weekStart: {
                immediate: true,
                handler(newDate) {
                    $('#meals-datepicker').datepicker('update', newDate)
                },
            }  
        },
        computed: {
            weekNumber() {
                return moment(this.weekStart).diff(this.programmeStartDate, 'weeks') + 1
            }
        },
        mounted() {
            var that = this

            $('#meals-datepicker')
                .datepicker({
                    language: _.get(window, 'locale', 'cs'),
                    autoclose: true,
                    container: '.calendar-week',
                    format: 'yyyy-mm-dd',
                    forceParse: false,
                    todayHighlight: true,
                    weekStart: 1,
                    templates: {
                        rightArrow:
                        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8 10.75L9.475 12.075C9.34167 12.225 9.275 12.4 9.275 12.6C9.275 12.8 9.34167 12.975 9.475 13.125C9.625 13.2583 9.8 13.325 10 13.325C10.2167 13.325 10.3917 13.2583 10.525 13.125L13 10.625C13.1833 10.4417 13.275 10.2333 13.275 10C13.275 9.76667 13.1833 9.55833 13 9.375L10.525 6.875C10.375 6.74167 10.2 6.675 10 6.675C9.8 6.675 9.625 6.74167 9.475 6.875C9.34167 7.00833 9.275 7.18333 9.275 7.4C9.275 7.61667 9.34167 7.79167 9.475 7.925L10.8 9.25H7C6.78333 9.25 6.6 9.325 6.45 9.475C6.31667 9.60833 6.25 9.78333 6.25 10C6.25 10.2167 6.31667 10.4 6.45 10.55C6.6 10.6833 6.78333 10.75 7 10.75H10.8ZM10 19.5C8.68333 19.5 7.44167 19.25 6.275 18.75C5.125 18.25 4.125 17.575 3.275 16.725C2.425 15.875 1.75 14.875 1.25 13.725C0.75 12.5583 0.5 11.3167 0.5 10C0.5 8.68333 0.75 7.45 1.25 6.3C1.75 5.13333 2.425 4.125 3.275 3.275C4.125 2.425 5.125 1.75 6.275 1.25C7.44167 0.749999 8.68333 0.499999 10 0.499999C11.3167 0.499999 12.55 0.749999 13.7 1.25C14.8667 1.75 15.875 2.425 16.725 3.275C17.575 4.125 18.25 5.13333 18.75 6.3C19.25 7.45 19.5 8.68333 19.5 10C19.5 11.3167 19.25 12.5583 18.75 13.725C18.25 14.875 17.575 15.875 16.725 16.725C15.875 17.575 14.8667 18.25 13.7 18.75C12.55 19.25 11.3167 19.5 10 19.5ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#5937B7"/></svg>`,
                        leftArrow:
                        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.2 10.75H13C13.2167 10.75 13.3917 10.6833 13.525 10.55C13.675 10.4 13.75 10.2167 13.75 10C13.75 9.78333 13.675 9.60833 13.525 9.475C13.3917 9.325 13.2167 9.25 13 9.25H9.2L10.525 7.925C10.6583 7.79167 10.725 7.61667 10.725 7.4C10.725 7.18333 10.6583 7.00833 10.525 6.875C10.3917 6.74167 10.2167 6.675 10 6.675C9.78333 6.675 9.60833 6.74167 9.475 6.875L7 9.375C6.81667 9.55833 6.725 9.76667 6.725 10C6.725 10.2333 6.81667 10.4417 7 10.625L9.475 13.125C9.625 13.2583 9.8 13.325 10 13.325C10.2167 13.325 10.3917 13.2583 10.525 13.125C10.6583 12.975 10.725 12.8 10.725 12.6C10.725 12.3833 10.6583 12.2083 10.525 12.075L9.2 10.75ZM10 19.5C8.68333 19.5 7.44167 19.25 6.275 18.75C5.125 18.25 4.125 17.575 3.275 16.725C2.425 15.875 1.75 14.875 1.25 13.725C0.75 12.5583 0.5 11.3167 0.5 10C0.5 8.68333 0.75 7.45 1.25 6.3C1.75 5.13333 2.425 4.125 3.275 3.275C4.125 2.425 5.125 1.75 6.275 1.25C7.44167 0.749999 8.68333 0.499999 10 0.499999C11.3167 0.499999 12.55 0.749999 13.7 1.25C14.8667 1.75 15.875 2.425 16.725 3.275C17.575 4.125 18.25 5.13333 18.75 6.3C19.25 7.45 19.5 8.68333 19.5 10C19.5 11.3167 19.25 12.5583 18.75 13.725C18.25 14.875 17.575 15.875 16.725 16.725C15.875 17.575 14.8667 18.25 13.7 18.75C12.55 19.25 11.3167 19.5 10 19.5ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#5937B7"/></svg>`,
                    }
                })
                .on('show changeMonth', function (e) {
                    setTimeout(function () {
                        var mealNotification = $('td .meal-notification')

                        if (mealNotification.length < 1) {
                            for (var i = 0; i < that.mealsDates.length; i++) {
                                if (moment(that.mealsDates[i].date).isDST()) {
                                    var hours = 2
                                } else {
                                    var hours = 1
                                }

                                var date = moment(that.mealsDates[i].date).hours(hours)
                                var dateNav = $("[data-date='" + date.valueOf() + "']")

                                if (dateNav.length > 0) {
                                    dateNav.append("<span class='meal-notification'></span>")
                                }
                            }

                            for (var i = 0; i < that.mealsNotifications.length; i++) {
                                if (moment(that.mealsNotifications[i].meal_date).isDST()) {
                                    var hours = 2
                                } else {
                                    var hours = 1
                                }

                                var date = moment(that.mealsNotifications[i].meal_date).hours(hours)
                                var dateCalendar = $("[data-date='" + date.valueOf() + "']")

                                if (dateCalendar.length > 0 && that.mealsNotifications[i].seen == false) {
                                    dateCalendar.find('.meal-notification').addClass('unseen')
                                } else {
                                    dateCalendar.find('.meal-notification').addClass('seen')
                                }
                            }
                        }
                    }, 10)
                })
                .on('changeDate', function(e) {
                    let date = moment(e.date).startOf('isoWeek').format('YYYY-MM-DD')

                    console.log(date)

                    that.$emit("weekChange", moment(date).format('YYYY-MM-DD'))
                })

            $('#meals-datepicker').datepicker('setDate', this.weekStart)
        }
    }
</script>
